import { groupBadgeStyle } from "@/lib/accountGroups";

export default function GroupBadge({ name, color, className = "", bold = true }) {
  if (!name) {
    return <span className={`font-mono-d text-[11px] text-app-muted uppercase ${bold ? "font-bold" : "font-semibold"} ${className}`}>—</span>;
  }
  const style = groupBadgeStyle(color);
  return (
    <span
      className={`inline-block px-2.5 py-1 font-mono-d text-[11px] uppercase tracking-wide border font-bold shadow-sm ${className}`}
      style={style}
    >
      {name}
    </span>
  );
}
